const Config = () => {
  return <>Config</>;
};
export default Config;

let globalVar = {
  url: 'https://hotelproapi.defconinnovations.com/',
  Token: localStorage.getItem('token') ?? '',
};

export const getGlobalVar = () => globalVar;
export const setGlobalVar = value => {
  globalVar.Token = value;
};
